module.exports = __webpack_public_path__ + "fonts/hk-grotesk.light.a4825540.ttf";